import { useContext, useCallback, useMemo } from 'react';
import { get } from 'lodash';
import { getFormContext } from './FormProvider';
const FormContext = getFormContext();
export const useComponentContext = (path) => {
    const formContext = useContext(FormContext);
    const value = useMemo(() => {
        console.log(`[useComponentContext] ✅ initial value for '${path}':`, formContext, value);
        if (!formContext?.initialized)
            return '';
        return get(formContext.values, path) ?? '';
    }, [formContext, path]);
    const onValueChange = useCallback((newValue) => {
        if (!formContext?.setFieldValue)
            return;
        console.log(`[useComponentContext] 📝 onValueChange triggered for '${path}' -> new value:`, newValue);
        const currentValue = get(formContext.values, path);
        if (currentValue === newValue)
            return;
        formContext.setFieldValue(path, newValue);
    }, [formContext, path]);
    return { value, onValueChange };
};
